export const RQ_GET_OFFERS = {
  url: 'api/offers/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_UPDATE_OFFERS= {
  url: 'api/offers/<%= id %>/update',
  method: 'PUT',
  auth:true,
};

export const  RQ_ADD_OFFERS = {
  url:'api/offers/register',
  method: 'POST',
  auth: true,
};

export const RQ_GET_OFFERS_BY_STATUS = {
  url: 'api/offers/lookup/by-status?status=ACTIVE',
  method: 'GET',
  auth: false,
};

export const RQ_DELETE_OFFERS = {
  url: 'api/offers/<%= id %>/delete',
  method: 'DELETE',
  auth: true,
};
